import { connect } from 'react-redux';
import { getProject } from 'project/ducks/project';
import { fetchPackageTipped } from 'entries/ducks';
import { isEliteParticipant } from 'project/utils';
import PackageTipped from 'entries/components/package_tipped';

const mapStateToProps = (state) => ({
  project: getProject(state),
  user: state.user.profile_data,
  isEliteParticipant: isEliteParticipant(state),
  packageTipped: state.entries.packageTipped
});

export default connect(mapStateToProps, { fetchPackageTipped })(PackageTipped);



// WEBPACK FOOTER //
// ./entries/containers/package_tipped.js